var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { sanitizeBaseUrl } from "../../../utils";
import { quizzesGetUserSubmissions, quizzesStoreUserSubmission } from "../../evo-client/__generated__";
export class QuizApiEvo {
    constructor(baseUrl, tenantToken, userToken) {
        this.tenantToken = tenantToken;
        this.userToken = userToken;
        this.client = createClient(createConfig({
            baseUrl: sanitizeBaseUrl(baseUrl),
            throwOnError: true,
        }));
    }
    getUserSubmissions(userUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield quizzesGetUserSubmissions({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.userToken,
                },
                path: {
                    userUuid,
                },
            });
            return data;
        });
    }
    createSubmission(userUuid, submission) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield quizzesStoreUserSubmission({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.userToken,
                },
                path: {
                    userUuid,
                },
                body: {
                    answers: submission.answers,
                    results: Object.assign({}, submission.results),
                    questions: submission.questions,
                },
            });
            return data;
        });
    }
}
//# sourceMappingURL=QuizApiEvo.js.map